import type { ShipmentTermsResponse } from './api';

export const normalizeShipmentTerms = (list: ShipmentTermsResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
